module.exports = __webpack_public_path__ + "img/5.d06e645a.png";